<template>
  <div>

    <Toolbar v-if="getCashier || getType==4 || getTerminal"/>

    <LiveMatchTrackerAmerican v-if="!this.checkIsMobile() && (this.getCurrentPage == 'live_detail'  || this.getCurrentPage == 'live_list')"></LiveMatchTrackerAmerican>

    <BetInAcceptance></BetInAcceptance>




  </div>
</template>

<script>
  import GetBookedBet from "@/components/right_widgets/GetBookedBet";
  import { mapGetters } from "vuex";
  import BetInAcceptance from "@/components/right_widgets/BetInAcceptance";
  import { isMobileOnly } from "mobile-device-detect";
  import LoadingSkeleton from "@/components/generic/LoadingSkeleton";
  import { checkIsMobileDevice } from "@/plugins/device-inspector";
  import QuizBet from "@/components/generic/QuizBet.vue";
  import LatestWins from "@/components/right_widgets/LatestWins.vue";

  const LiveMatchTrackerAmerican = () => ({
    component: import('@/components/american/LiveMatchTrackerAmerican'),
    loading: LoadingSkeleton,
    timeout: 200
  })

  import Toolbar from "@/components/generic/Toolbar.vue";

  export default {
    name: 'Right',
    components: {
      QuizBet,
      BetInAcceptance,
      LoadingSkeleton,
      LiveMatchTrackerAmerican,
      GetBookedBet,
      LatestWins,
      Toolbar
    },
    data: () => ({
      isMobileOnly: isMobileOnly,
    }),
    computed: {
      ...mapGetters({
        'getGameConsole': 'settings/getGameConsole',
        'getViewMode': 'ui/getViewMode',
        'getCurrentPage': 'sportNavigation/currentPage',
        'getEventsLiveDetail': 'detailLive/getEventsLiveDetail',
        'getBet': 'cart/getBet',
        'getType': 'user/getType',
        'getCashier': 'user/getCashier',
        'getUiPersonalizationRight': 'settings/getUiPersonalizationRight',
        'getTerminal': 'user/getTerminal'
      }),

    },
    methods: {
      checkIsMobile() {
        return checkIsMobileDevice()
      },
    }
  };
</script>
